import LocationCard from "./LocationCard";
import LocationCardPreloader from "./LocationCardPreloader";

import { ILocationCard } from "./ILocationCard"


const LocationCardComponent = LocationCard as React.FC<ILocationCard> & { Loading: typeof LocationCardPreloader; };

LocationCardComponent.Loading = LocationCardPreloader;
export type { ILocationCard };
export default LocationCardComponent;
